export const HUMAN = 'HUMAN';
export const BOT = 'BOT';